import React from "react";
import classes from "./TreeList.module.scss";
import TreeItem from "./TreeItem";
import { useState } from "react";
import useComponentVisible from "../../../../hooks/useComponentVisible";

const TreeList = ({
  height = "5.1",
  setCategoryId,
  width = "24.7",
  productCategory,
  placeholder,
  label,
  light,
  setcatagoryName,
  catagoryName,
}) => {
  const [listVisible, setListVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [tagListRef, isTagListVisible, setTagListVisible] =
    useComponentVisible();

  const handleSelected = (name, id) => {
    setSelectedCategory(name);
    setCategoryId(id);
  };

  return (
    <div style={{ position: "relative" }}>
      {label && (
        <label
          style={{
            color: light ? "#707070" : "#404040",
            // display: isRadioBtn ? "overlay" : " ",
          }}
          className={classes.label}
        >
          {label}
        </label>
      )}

      <div>
        <input
          type={"text"}
          style={{
            width: width + "rem",
            height: height + "rem",
          }}
          placeholder={placeholder}
          onClick={(e) => {
            e.stopPropagation();
            setTagListVisible(!isTagListVisible);
          }}
          className={classes.textForm}
          value={catagoryName}
        />
        {isTagListVisible && (
          <div className={classes.options} ref={tagListRef}>
            <ul style={{ listStyle: "none" }}>
              {productCategory?.map((category) => {
                if (category.SubCategory?.length > 0) {
                  return (
                    <TreeItem
                      setTagListVisible={setTagListVisible}
                      setSelectedCategory={setcatagoryName}
                      setCategoryId={setCategoryId}
                      category={category}
                    />
                  );
                } else {
                  return (
                    <li
                      className={classes.inputOptions}
                      onClick={() => {
                        setTagListVisible(false);
                        handleSelected(category.Name, category.CategoryId);
                        setcatagoryName(category.Name);
                      }}
                    >
                      <span>{category.Name}</span>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default TreeList;
